<!--- Formulario PCPopupGetDataForNewPale ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-
Eventos escuchados por el componente:
-----------------------

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-block>
    <f7-popup
      class="new-pale-popup add-new-palet-popup"
      :close-by-backdrop-click="false"
      :opened="popupOpened"
      @popup:closed="popupOpened = false"
    >
      <f7-page>
        <template #fixed>
          <TheNavbar
            :nav-title="$t('commercialization.picking.palletizing.getDataForNewPale.title')"
            class="secondary-navbar"
            popup-close-btn-enable
          />
        </template>

        <div class="popup-search">
          <div
            v-if="conPedido"
            class="searchPale"
          >
            <UCSearchEntityERP
              ref="UCPaleNewPale"
              :title="$t('common.pallet').toUpperCase()"
              :placeholder="$t('searchEntity.pallet.placeholder.selectAPallet')"
              :search-text="$t('searchEntity.pallet.searchText')"
              :search-cancellation-text="$t('searchEntity.pallet.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.pallet.searchNotFoundText')"
              :emit-evet-change-default-value="true"
              :default-value="pale?.LineaPedidoVenta?.InfoPale"
              :property-entity-shown-input="['Nombre']"
              :property-entity-shown-list-title="['Nombre']"
              :min-text-search="0"
              :end-point-for-list="GetPaleList"
              @selection="(value) => newDataPale.TipoPale = value"
            />
          </div>
          <div
            v-else
            class="searchPale"
          >
            <UCSearchEntityERP
              ref="UCPaleNewPale"
              :title="$t('common.pallet').toUpperCase()"
              :placeholder="$t('searchEntity.pallet.placeholder.selectAPallet')"
              :search-text="$t('searchEntity.pallet.searchText')"
              :search-cancellation-text="$t('searchEntity.pallet.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.pallet.searchNotFoundText')"
              :emit-evet-change-default-value="true"
              :property-entity-shown-input="['Nombre']"
              :property-entity-shown-list-title="['Nombre']"
              :min-text-search="0"
              :end-point-for-list="GetPaleList"
              @selection="(value) => newDataPale.TipoPale = value"
            />
          </div>
          <div class="searchUbicacion">
            <UCSearchEntityERP
              ref="UCUbicacionDestinoNewPale"
              :title="$t('searchEntity.location.title.producedPallesLocation').toUpperCase()"
              :placeholder="$t('searchEntity.location.placeholder.selectATargetLocation')"
              :search-text="$t('searchEntity.location.searchText')"
              :search-cancellation-text="$t('searchEntity.location.searchCancellationText')"
              :search-not-found-text="$t('searchEntity.location.searchNotFoundText')"
              :default-value="ubicacionDefectoEntradaLocal"
              :min-text-search="0"
              :emit-evet-change-default-value="true"
              :property-entity-shown-input="['Nombre']"
              :property-entity-shown-list-title="['Nombre']"
              :end-point-for-list="GetDestinationLocation"
              @selection="(value) => newDataPale.Ubicacion = value"
            />
          </div>
        </div>
        <div class="popup-add-palet-footer">
          <div>
            <f7-row>
              <f7-col>
                <f7-button
                  class="btn-popup-cancel"
                  popup-close
                  @click="Cancel"
                >
                  {{ $t('common.cancel') }}
                </f7-button>
              </f7-col>
              <f7-col>
                <f7-button
                  class="btn-popup-confirm"
                  @click="Confirm"
                >
                  {{ $t('common.confirm') }}
                </f7-button>
              </f7-col>
            </f7-row>
          </div>
        </div>
      </f7-page>
    </f7-popup>
  </f7-block>
</template>

<script>
import { useParamRef } from '@erpagroapp/params';
import { LogDetails as Log } from '@/js/common/HIDebuggingSupport';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import TheNavbar from '@/components/TheNavbar.vue';
import ConexionTA, { callObtenerArticulos } from '@/js/services/traceability/APITraceability';
import {
  HiNotification,
} from '@/js/common/HINotificationSupport';
import { TipoArticulo } from '@/js/common/enum';
import { deepToRaw } from '@/js/utils/deepToRaw';

/** @import { InfoNuevoArticuloNumeroSerie } from '@erpagroapp/types' */

export default {
  name: 'PCPopupGetDataForNewPale',
  components: {
    UCSearchEntityERP,
    TheNavbar,
  },
  props: {
    selectedPale: { type: Object, default: null },
    conPedido: { type: Boolean, default: true },
  },

  emits: ['confirm'],

  data() {
    return {
      ubicacionDefectoEntradaLocal: null,
      popupOpened: false,
      /** @type {InfoNuevoArticuloNumeroSerie} */
      newDataPale: {
        TipoPale: null,
        Ubicacion: null,
      },
      pale: null, // pale seleccionado
      ubicacionDefectoEntrada: useParamRef('UbicacionDefectoEntrada'),
    };
  },
  watch: {
    selectedPale(val) {
      this.pale = val;
    },
    ubicacionDefectoEntrada(val) {
      this.ubicacionDefectoEntradaLocal = val ? structuredClone(deepToRaw(val)) : null;
    },
  },

  mounted() {
    Log(this, 'PCPopupGetDataForNewPale->mounted');
    this.StartComponent();
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      if (this.conPedido) {
        this.pale = this.selectedPale;
        this.newDataPale.TipoPale = this.pale;
      }
      this.ubicacionDefectoEntradaLocal = this.ubicacionDefectoEntrada ? structuredClone(deepToRaw(this.ubicacionDefectoEntrada)) : null;
    },
    ResetComponent() {
      Log(this, this.ResetComponent.name);
    },

    /**
     * @public
     * @returns {void}
     */
    Show() {
      Log(this, this.Show.name);
      this.popupOpened = true;
    },

    Confirm() {
      Log(this, this.Confirm.name);
      if (!this.ValidateData()) {
        return;
      }
      this.$emit('confirm', this.newDataPale);
      this.popupOpened = false;
    },
    Cancel() {
      Log(this, this.Cancel.name);
      if (this.conPedido) {
        this.$refs.UCPaleNewPale.SelectEntity(this.pale.LineaPedidoVenta.InfoPale, true);
      }
      if (this.ubicacionDefectoEntradaLocal) {
        this.$refs.UCUbicacionDestinoNewPale.SelectEntity(this.ubicacionDefectoEntradaLocal, true);
      }
      // this.$refs.UCUbicacionDestinoNewPale.Clear();
    },
    ValidateData() {
      Log(this, this.ValidateData.name);
      if (!this.newDataPale.TipoPale) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.getDataForNewPale.needToSelectPalletType'));
        return false;
      }

      if (!this.newDataPale.Ubicacion) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.getDataForNewPale.needToSelectDestination'));
        return false;
      }

      return true;
    },
    async GetPaleList() {
      Log(this, this.GetPaleList.name);
      return new Promise((resolve, reject) => {
        callObtenerArticulos({ tipoArticulo: TipoArticulo.Palet }).then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(new Error('Error'));
          }
        });
      });
    },
    async GetDestinationLocation() {
      Log(this, this.GetDestinationLocation.name);
      return new Promise((resolve, reject) => {
        ConexionTA.callObtenerUbicaciones().then((result) => {
          if (result.Valor) {
            resolve({ data: JSON.parse(result.Mensaje) });
          } else {
            reject(new Error('Error'));
          }
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.add-new-palet-popup {
  width: 383px;
  height: 371px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -200px;
  margin-left: -175px;
  border-radius: 4px;
}

.head-popup {
  background: #dfe1e5;
}

.head-btn {
  width: 50px;
  height: 50px;
  float: right;
}

.head-text {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: var(--his-steel-blue);
  margin-top: 15px;
  margin-left: 15px;
}

.popup-add-palet-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}

.popup-search {
  width: 350px;
  height: 35px;
  margin-left: 25px;
}

.searchPale {
  margin-top: 25px;
  height: 75px;
}

.btn-popup-cancel {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #c1c1c1;
  width: 150px;
}
</style>
